import { gsap, ScrollTrigger, SplitText, Flip } from "../shared/globals.js";

export const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const CONFIG = {
    mode: "auto",
    tigerAppearDelay: 0.3,
    tigerAppearDuration: 0.8,
    elementsAppearDuration: 0.6,
    elementsStagger: 0.1,
    expandDuration: 1.2,
    repositionDuration: 1.2,
    tigerFinalWidth: "20rem",
    expandingImgFinalWidth: "27.875rem",
    parallaxIntensity: 15,
    parallaxSmoothing: 0.08,
    scrubSmoothness: 1,
    scrollDistance: "200%",
    backgroundImgOpacity: 0.7,
    tigerWalkFrameRate: 120,
    tigerWalkFrames: 6,
    tigerWalkPauseDuration: 0,
    brandTigerScrollPixelsPerFrame: 48,
    brandTigerScrollActivationDistance: 24,
};

let pluginsRegistered = false;

export function registerGsapPlugins() {
    if (pluginsRegistered) return;

    gsap.registerPlugin(ScrollTrigger, Flip, SplitText);
    pluginsRegistered = true;
}
